import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

// Define available variants (replacing class-variance-authority)
type LabelVariants = {
  size?: 'default' | 'small' | 'large';
  weight?: 'medium' | 'bold';
};

// Helper function to generate class names based on variants
const getLabelClassName = (variants?: LabelVariants) => {
  const classes = [ 'label' ];

  if (variants?.size === 'small') classes.push('small');
  if (variants?.size === 'large') classes.push('large');
  if (variants?.weight === 'bold') classes.push('bold');

  return classes.join(' ');
};

interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>, LabelVariants {}

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, size = 'default', weight = 'medium', ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={`${getLabelClassName({ size, weight })} ${className || ''}`}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
